import React, {
    useContext,
    useEffect,
    useMemo,
    useState,
    useCallback,
} from "react";
import ReactTable from "../../components/ReactTable/ReactTable.jsx";
import { Link, useNavigate } from "react-router-dom";
import { config } from "../../config.js";
import { SidebarContext } from "../../context/SidebarContext";
import SectionMenuLeft from "../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import "./Pincodes.css";
import { toast } from "react-toastify";
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import { LuArrowLeft } from "react-icons/lu";


function Pincodes() {

    const { isSidebar, adminPermissions } = useContext(SidebarContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [pincodes, setPincodes] = useState([])


    const getPincodes = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${config?.backEndBaseUrl}booking/pincode/stats`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-dashboard-request": "true",
                    },
                },
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();

            if (result.success && Array.isArray(result.data)) {

                const sorted = result.data.sort((a, b) => {
                    const timeA = a?.lastSearchedAt?._seconds || 0;
                    const timeB = b?.lastSearchedAt?._seconds || 0;
                    return timeB - timeA; 
                });

                setPincodes(sorted);

            } else {
                setPincodes([]);
            }
        } catch (error) {
            console.error("Fetching drivers failed:", error);
            setPincodes([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        getPincodes()
    }, [])

    const columns = useMemo(
        () => [
            { accessorKey: "pincode", header: "pincode" },
            { accessorKey: "searchCount", header: "Total Searches" },
            {
                accessorKey: "lastSearchedAt",
                header: "Last Searched",
                Cell: ({ cell }) => {
                    const value = cell.getValue();

                    if (!value || !value._seconds) return "-";

                    return new Date(value._seconds * 1000).toLocaleString("en-IN", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    });
                },
            },
        ],
        []
    );

    return (
        <div className="body">
            <div id="wrapper">
                <div id="page">
                    <div className="layout-wrap">
                        <SectionMenuLeft />
                        <div className="section-content-right">
                            <div
                                className="main-content"
                                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
                            >
                                <div className="main-content-inner">
                                    <div className="main-content-wrap">
                                        <div className="tf-section">
                                            <div className="wg-box" style={{ marginBottom: 20 }}>
                                                <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                                                    <div className="flex items-center gap-3">
                                                        <button
                                                            className="back-btn flex items-center gap-2"
                                                            onClick={() => navigate("/")}
                                                        >
                                                            <LuArrowLeft size={16} />
                                                        </button>

                                                        <h5 className="fare-heading">Unavailable Pincodes</h5>
                                                    </div>
                                                </div>
                                                {loading ? (
                                                    <div className="skeleton-table">
                                                        {[...Array(6)].map((_, i) => (
                                                            <div className="skeleton-row" key={i}>
                                                                <div className="skeleton skeleton-name"></div>
                                                                <div className="skeleton skeleton-photo"></div>
                                                                <div className="skeleton skeleton-phone"></div>
                                                                <div className="skeleton skeleton-email"></div>
                                                                <div className="skeleton skeleton-status"></div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <>
                                                        <ReactTable columns={columns} data={pincodes} />
                                                    </>
                                                )}



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pincodes;
